import React, { useState } from 'react';
import { Button } from '../button';
import { MyModal } from '../my-modal';

interface IConfirmModal {
  confirm: () => void;
  texts: {
    title: string;
    text: string;
    cancel: string;
    confirm: string;
  };
  /** Деструктивное действие? Если да — кнопка подтверждения красная,
   *  «Отмена» становится первичной (нейтральной). По умолчанию false. */
  danger?: boolean;
  openButton: JSX.Element;
  children?: JSX.Element;
}

const ConfirmModal = ({
  confirm = () => {},
  texts = { title: '', text: '', cancel: '', confirm: '' },
  danger = false,
  openButton = <></>,
  children = <></>,
}: IConfirmModal) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleConfirm = () => {
    confirm();
    setIsOpen(false);
  };

  const handleCancel = () => setIsOpen(false);

  const openModal = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setIsOpen(true);
  };

  return (
    <>
      {React.cloneElement(openButton, { onClick: openModal })}
      <MyModal isOpen={isOpen} onClose={handleCancel} size="sm" title={texts.title}>
        <p className="text-sm text-[#4A4F5A] leading-relaxed">{texts.text}</p>
        {children}
        <div className="flex items-center justify-end gap-2 mt-6">
          <Button isWhite onClick={handleCancel}>
            {texts.cancel}
          </Button>
          <Button
            onClick={handleConfirm}
            className={
              danger
                ? 'bg-[#e3282a] hover:bg-[#c82022] text-white border-none'
                : ''
            }
          >
            {texts.confirm}
          </Button>
        </div>
      </MyModal>
    </>
  );
};

export default ConfirmModal;
